import { render } from "./prescriptionGoodsPayment.vue?vue&type=template&id=9ea5c57c&scoped=true"
import script from "./prescriptionGoodsPayment.vue?vue&type=script&lang=js"
export * from "./prescriptionGoodsPayment.vue?vue&type=script&lang=js"

import "./prescriptionGoodsPayment.vue?vue&type=style&index=0&id=9ea5c57c&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ea5c57c"]])

export default __exports__